/* eslint-disable */
import { Skeleton, useToast } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { useApproveFundingRequestMutation } from 'capitalProvider/domains/fundingRequests/requests/fundingRequests.gql.generated';
import {
  errorToastConfig,
  errorToastId,
  successToastConfig,
} from 'packages/common-frontend/constants';

export const ApproveFundingRequest = ({
  fundingRequestId,
}: {
  fundingRequestId: string;
}) => {
  const toast = useToast();
  const [approveFundingRequest, { loading }] = useApproveFundingRequestMutation(
    {
      variables: { fundingRequestId },
      onCompleted: () => {
        if (!toast.isActive(successToastConfig.id)) {
          successToastConfig.title = 'Funding Request Approved';
          toast(successToastConfig);
        }
      },
      onError: () => {
        if (!toast.isActive(errorToastId)) {
          errorToastConfig.title = `Error approving funding request`;
          toast(errorToastConfig);
        }
      },
    },
  );

  useEffect(() => {
    approveFundingRequest();
  }, [approveFundingRequest]);

  if (loading) {
    <Skeleton height="600px" data-testid="approve-funding-requests-loading" />;
  }

  return <Navigate to={`/funding-requests/${fundingRequestId}`} />;
};
